import { useNavigate, Link } from 'react-router-dom'
import dateFormat from 'dateformat'

import { CopyTextToClipboard } from '../obj/history';

import useUserManagement from '../hooks/useUserManagement'
import { openUrlFor } from '../hooks/useSharePointToken'

const useTempateSlots = () => {
    const navigate = useNavigate()

    const {
        getUserFromID,
    } = useUserManagement()

    const dateSlot = (data, type, row) => {
        if (data === null) return ''
        if (type === 'sort') return dateFormat(data, 'yyyy-mm-dd')
        if (type !== 'display') return dateFormat(data, 'dd-mm-yyyy')
        return <span style={{whiteSpace: 'nowrap'}}>{dateFormat(data, 'dd-mm-yyyy')}</span>
    }

    const filePathSlot = (data, type, row) => {
        // For the sorting!
        if( type !== 'display') {
            if(data === '') return 'xxxempty' // to sort them last
            return data.match(/^http/i) ? 'http' : 'clipboard'
        }
        
        if (typeof(data) === 'undefined') return ''
        if (data === '') return ''

        const status = row.record_status?.name || row.document_status?.name
        const cssClass = "status_" + status
        const openTooltip = ( status && status === "Reserved" )
                          ? "Open Draft Document"
                          : "Open Document"
        const copyTooltip = ( status && status === "Reserved" )
                          ? "Copy Draft Filepath to Clipboard"
                          : "Copy Filepath to Clipboard"
            
        if (data.match(/^http/i)) {
            return (
                <a href={openUrlFor(data)} target="_blank" rel="noreferrer" data-tooltip-id="gnctooltip" data-tooltip-content={openTooltip}>
                    <i className={`fa fa-file-o ${cssClass}`}></i>
                </a>
            )
        }
        return (
            <a href="#" onClick={(e) => { e.preventDefault(); CopyTextToClipboard(e, data)}} data-tooltip-id="gnctooltip" data-tooltip-content={copyTooltip}>
                <i className={`fa fa-copy ${cssClass}`}></i>
            </a>
        )
    }

    const linkSlot = (data, type, row, url, callback) => {
        if( type !== 'display') { return data }
        if (data === '') return ''
        return (
            <a href={url} rel="noreferrer" onClick={(e) => {
                // ctrl+click for normal users
                if(e.ctrlKey) return;
                // ctrl+click for mac users
                if(e.metaKey) return;

                e.preventDefault();
                if( typeof callback === 'function' ) {
                    callback()
                }
                navigate(url);
            }}
                >
                    {data}
                </a>
        )
    }
    
    const ownerSlot = (data, type, row) => { // TODO: Rename to userSlot. I think.
        const user = getUserFromID(data) // row.owner_user_id)
        if( type !== 'display') {
            return user.display_name
        }
        return <span data-tooltip-id="gnctooltip" data-tooltip-content={user.label}>{user.display_name}</span>
    }

    return {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    }
}

export default useTempateSlots
